import React from "react"
import styled from "styled-components"
import Planet from "Galaxy/wrappers/Planet"
import PlanetImage from "Galaxy/wrappers/PlanetImage"
import union from "galaxies/green-galaxy/union.svg"

const Union = props => (
  <Planet {...props}>
    <PlanetImage src={union} blocked={props.blocked} />
  </Planet>
)

export default styled(Union)``
